import React from "react";
import { useRouter } from "next/router";

const Banner = ({ title }) => {
  const router = useRouter();

  const handleButtonClick = () => {
    router.push("/");
  };

  return (
    <section className="banner">
      <div className="banner-content">
        <h1 dangerouslySetInnerHTML={{ __html: title }} />
        <button className="visit-button" onClick={handleButtonClick}>VISIT OUR WEBSITE</button>
      </div>
    </section>
  );
};

export default Banner;
